import React from 'react';
import { locationResponseFormatter } from '../../../../reducers/formatters/location';
import { getLocationUrl } from '../../../../core/dapi/location';
import { apiGet } from '../../../../core/dapi';
import { EMPTY_OBJECT } from '../../../../core/util/object';

export const NUMBER_IN_LINE = '/number-in-line';

export default {
  path: NUMBER_IN_LINE,
  get: ({ query }: any) =>
    import(/* webpackChunkName: 'numberInLine' */ '../../../../components/NumberInLine').then(
      async (module) => {
        let err;

        const location = locationResponseFormatter(
          await apiGet(getLocationUrl(query.lid)).catch(() => {
            err = `Could not access Solv (${query.lid})`;
            return EMPTY_OBJECT;
          })
        );

        const NumberInLine = module.default;

        return {
          component: <NumberInLine err={err} ff={query.ff} location={location} />,
        };
      }
    ),
};
